/* ======= DYNAMIC IMAGE ASSOCIATION FUNCTIONALITY ======= */
(function () {
  'use strict';

  if (window.RCToiMoiGalleryInitialized) return;
  window.RCToiMoiGalleryInitialized = true;

  /* ======= Shared: resolve metal letter from DOM ======= */
  function getMetalLetter() {
    const checkedMetal =
      document.querySelector('input[name="Metal"]:checked') ||
      document.querySelector('[data-option-name="Metal"] input:checked');
    if (!checkedMetal) return 'y';
    const metal = checkedMetal.value.toLowerCase();
    if (metal.includes('white')) return 'w';
    if (metal.includes('rose'))  return 'r';
    return 'y';
  }

  /* ======= Shared: fetch image URL for any combination key ======= */
  async function fetchCombinationImage(combination) {
    if (!combination) return null;
    try {
      const response = await fetch(`${window.portalApiUrl}/color_combination/${combination}`);
      const result   = await response.json();
      if (result?.status && result?.data?.length) return result.data[0];
      return null;
    } catch (error) {
      console.error('[RC Dynamic Image] Fetch error:', error);
      return null;
    }
  }

  /* ======= Shared: sync a hidden property input to the cart form ======= */
  function syncPropertyToForm(propertyName, value) {
    const form = document.querySelector('form.form[action="/cart/add"]');
    if (!form) return;
    let input = form.querySelector(`input[name="properties[${propertyName}]"]`);
    if (!input) {
      input      = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${propertyName}]`;
      form.appendChild(input);
    }
    input.value = value;
  }

  /* ======= Shared: update all gallery targets with a resolved image URL ======= */
  // callerType: 'toi_moi' | 'engraving'
  function updateGalleryImage(imageUrl, callerType) {
    if (!imageUrl) return;

    // ====== Persist image URL as a cart property ======
    if (callerType === 'toi_moi') {
      syncPropertyToForm('_toi_moi_image', imageUrl);
    } else if (callerType === 'engraving') {
      syncPropertyToForm('_engraving_image', imageUrl);
    }

    const sectionId      = window.__rcToiMoiSectionId;
    const featureMediaId = window.__rcToiMoiFeatureMediaImageId;

    if (!sectionId || !featureMediaId) {
      console.warn('[RC Dynamic Image] Missing sectionId or featureMediaId', { sectionId, featureMediaId });
      return;
    }

    /* ======= Update every img that references this mediaId ======= */
    /* Covers: main slide, infinite-loop clone, modal slide */
    const mediaSelectors = [
      `#Slide-${sectionId}-${featureMediaId} img`,
      `[data-clone-from="#Slide-${sectionId}-${featureMediaId}"] img`,
      `#ProductModal-${sectionId} [data-media-id="${featureMediaId}"] img`,
    ];

    mediaSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((img) => {
        img.src    = imageUrl;
        img.srcset = imageUrl;
        img.setAttribute('src', imageUrl);
        img.setAttribute('srcset', imageUrl);
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.classList.add('image-lazy-loaded');
        img.classList.remove('loading-animation--breathing');
      });
    });

    /* ======= Update the thumbnail that points to this mediaId ======= */
    /* After rc-associated-images.js reorders DOM, thumbnail-0 may not be the right one — find by data-target instead ======= */
    const thumbItem = document.querySelector(
      `#Gallery-Thumbnail-Slider-${sectionId} [data-target="${featureMediaId}"] img`
    );
    if (thumbItem) {
      thumbItem.src    = imageUrl;
      thumbItem.srcset = imageUrl;
      thumbItem.setAttribute('src', imageUrl);
      thumbItem.setAttribute('srcset', imageUrl);
      thumbItem.removeAttribute('data-src');
      thumbItem.removeAttribute('data-srcset');
      thumbItem.classList.add('image-lazy-loaded');
      thumbItem.classList.remove('loading-animation--breathing');
    }

    /* ======= Force gallery to show the updated slide via data-target button ======= */
    const thumbButton = document.querySelector(
      `#Gallery-Thumbnail-Slider-${sectionId} [data-target="${featureMediaId}"] button`
    );
    if (thumbButton) {
      thumbButton.click();
    }
  }

  /* ======= Shared: build a normalised combination key from parts ======= */
  function buildCombinationKey(...parts) {
    return parts
      .filter(Boolean)
      .join('-')
      .toLowerCase()
      .replaceAll(' ', '-')
      .replace(/[()]/g, '');
  }

  /* ======= Shared: fetch + update in one call ======= */
  // callerType is forwarded so updateGalleryImage knows which property to write
  async function updateGalleryForCombination(combination, callerType) {
    const imageUrl = await fetchCombinationImage(combination);
    if (!imageUrl) return;
    updateGalleryImage(imageUrl, callerType);
    if(callerType === 'toi_moi') window.__rcToiMoiGeneratedImage = imageUrl;
    if(callerType === 'engraving') window.__rcEngravingGeneratedImage = imageUrl;
  }

  // Expose for external callers
  window.__rcUpdateGalleryForCombination = updateGalleryForCombination;
  window.__rcBuildCombinationKey         = buildCombinationKey;
  window.__rcGetMetalLetter              = getMetalLetter;

  /* ======= TOI ET MOI ======= */
  function updateToiMoiGallery() {
    const data     = window.__rcToiStoneData || {};
    const stoneOne = data[1]?.title || '';
    const stoneTwo = data[2]?.title || '';
    if (!stoneOne || !stoneTwo) return;
    const key = buildCombinationKey(getMetalLetter(), stoneOne, stoneTwo);
    updateGalleryForCombination(key, 'toi_moi');
  }

  /* ======= ENGRAVING ======= */
  function updateEngravingGallery() {
    const d = window.__rcEngravingImageData || {};
    if (!d.font || !d.stoneShape) return;

    const metal = getMetalLetter();
    let key;
    /* ======= Updating param for Signet Ring :: Duo & Pave Ring ======= */
    if (d.productId === '7973256822872') {
      // Pattern: {metal}--{font}-duo
      key = `${metal}--${d.font.toLowerCase().replaceAll(' ', '-')}-duo`;
    } else if (d.productId === '7973232869464') {
      // Pattern: {metal}--{font}-pave
      key = `${metal}--${d.font.toLowerCase().replaceAll(' ', '-')}-pave`;
    } else {
      if (!d.placement) return;
      key = buildCombinationKey(metal, d.stoneShape, d.font, d.placement);
    }
    updateGalleryForCombination(key, 'engraving');
  }

  /* ======= Event listeners ======= */
  function attachListeners() {
    /* ======= Toi et Moi — only on its specific triggers ======= */
    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('.rc-toi-stone-option, .custom-dropdown__option, .variant-input');
      if (!trigger) return;
      setTimeout(updateToiMoiGallery, 100);
    });

    /* ======= Toi et Moi — scoped change listener, NOT global ======= */
    const toiMoiContainer = document.querySelector('.rc-toi-moi-container, [data-toi-moi]');
    if (toiMoiContainer) {
      toiMoiContainer.addEventListener('change', function () {
        setTimeout(updateToiMoiGallery, 100);
      });
    } else {
      /* ======= Fallback: listen on document but skip variant input changes ======= */
      document.addEventListener('change', function (e) {
        if (e.target?.name === 'id') return; // ← skip variant switches
        setTimeout(updateToiMoiGallery, 100);
      });
    }

    /* ======= Engraving events ======= */
    document.addEventListener('rc:engraving:selectionChanged', function () {
      setTimeout(updateEngravingGallery, 100);
    });

    document.addEventListener('rc:engraving:metalChanged', function () {
      setTimeout(updateEngravingGallery, 100);
    });
  }

  function init() {
    attachListeners();
    setTimeout(updateToiMoiGallery, 500);
    setTimeout(updateEngravingGallery, 500);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();